var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOccamxSmClip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    viewBox: "0 0 272 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "objectBoundingBox",
    id: "occamxSmBorder",
    transform: "scale(0.00367647, 0.00238095)"
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M262.592 1.57773C267.075 1.00546 271.042 4.4985 271.042 9.01796V410.816C271.042 414.959 267.684 418.317 263.541 418.317H206.865C204.357 418.317 202.015 417.064 200.624 414.977L190.076 399.155C188.685 397.068 186.343 395.815 183.835 395.815H23.5221C19.3796 395.815 16.0215 392.457 16.0215 388.315V132.492C16.0215 130.634 15.1606 128.881 13.6904 127.744L3.26565 119.687C1.79542 118.551 0.93457 116.798 0.93457 114.939V40.2619C0.93457 37.2417 3.17934 34.6922 6.17525 34.3098L262.592 1.57773Z",
    fill: "white",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 1.48298
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccamxSmClip);
export default __webpack_public_path__ + "static/media/occamx-sm-clip.3d95c73c.svg";
export { ForwardRef as ReactComponent };